import { AdminOrganizationMembersTile } from '@components/pages/admin/organizations/components/admin-organization-members-tile.component';
import { useAdminOrganizationDetailQuery } from '@queries/admin-organizations.query';
import { Loader2Icon } from 'lucide-react';
import { type FC, Suspense } from 'react';

type AdminIntelTeamStepProps = {
  companyId: string;
};

// AZ-451 D9: Team step for admin-created Intelligence orgs. The org is already created on entering
// this step, so we reuse the org-detail Members tile (approved-user search + persona add, live
// persona changes, removals) against the new org id instead of innovator email invites.
const AdminIntelTeamStepContent: FC<AdminIntelTeamStepProps> = (props) => {
  const { companyId } = props;
  const { data: organization } = useAdminOrganizationDetailQuery(companyId);

  return <AdminOrganizationMembersTile organization={organization} />;
};

export const AdminIntelTeamStep: FC<AdminIntelTeamStepProps> = (props) => {
  const { companyId } = props;

  if (!companyId) {
    return null;
  }

  return (
    <Suspense
      fallback={
        <div className="flex justify-center py-8">
          <Loader2Icon className="size-5 animate-spin text-gray-400" />
        </div>
      }
    >
      <AdminIntelTeamStepContent companyId={companyId} />
    </Suspense>
  );
};
